import { Loader2, Zap } from "lucide-react";

const VARIANTS = [
  { key: "classic", label: "Classic", desc: "Double stake on every loss" },
  { key: "grand", label: "Grand", desc: "Double + 1 base unit on every loss" },
  { key: "mini", label: "Mini", desc: "Capped doubling at step 4" },
  { key: "anti", label: "Anti (Reverse)", desc: "Double on wins, reset on loss" },
  { key: "dalembert", label: "D'Alembert", desc: "+1 unit per loss, −1 per win" },
];

const NUMERIC_INPUTS = [
  { k: "base_stake", label: "BASE STAKE ($)", step: 1, min: 1 },
  { k: "bankroll", label: "BANKROLL ($)", step: 50, min: 10 },
  { k: "table_limit", label: "TABLE / BOOK LIMIT ($)", step: 100, min: 0 },
  { k: "american_odds", label: "AMERICAN ODDS", step: 1, min: -500, max: 500 },
  { k: "max_steps", label: "MAX STEPS TO COMPUTE", step: 1, min: 1, max: 20 },
];

function VariantPicker({ value, onChange }) {
  return (
    <div>
      <label className="overline block mb-2">VARIANT</label>
      <div className="space-y-2">
        {VARIANTS.map((v) => (
          <label
            key={v.key}
            className={`flex items-start gap-3 border p-3 cursor-pointer transition-colors ${
              value === v.key
                ? "border-[#00D4FF] bg-[#00D4FF]/5"
                : "border-zinc-800 hover:border-zinc-600"
            }`}
            data-testid={`variant-${v.key}`}
          >
            <input
              type="radio"
              name="variant"
              checked={value === v.key}
              onChange={() => onChange(v.key)}
              className="mt-1 accent-[#00D4FF]"
            />
            <div>
              <div className="mono text-sm text-white">{v.label}</div>
              <div className="text-xs text-zinc-500">{v.desc}</div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}

export default function CalculatorForm({ form, update, onSubmit, loading }) {
  return (
    <form
      className="lg:col-span-4 border border-zinc-800 p-6 space-y-5 bg-zinc-950/60 h-fit"
      onSubmit={onSubmit}
    >
      <div className="overline">INPUTS</div>

      <VariantPicker value={form.variant} onChange={(v) => update("variant", v)} />

      {NUMERIC_INPUTS.map((f) => (
        <div key={f.k}>
          <label className="overline block mb-2">{f.label}</label>
          <input
            type="number"
            value={form[f.k]}
            step={f.step}
            min={f.min}
            max={f.max}
            data-testid={`input-${f.k}`}
            onChange={(e) => update(f.k, e.target.value)}
            className="w-full bg-transparent border border-zinc-800 px-3 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          />
        </div>
      ))}

      <div>
        <label className="overline block mb-2">
          WIN PROBABILITY · {(Number(form.win_probability) * 100).toFixed(0)}%
        </label>
        <input
          type="range"
          min={0.3}
          max={0.7}
          step={0.01}
          value={form.win_probability}
          onChange={(e) => update("win_probability", e.target.value)}
          data-testid="input-win_probability"
          className="w-full accent-[#00D4FF]"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        data-testid="calc-submit"
        className="w-full py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs disabled:opacity-50 hover:brightness-110 flex items-center justify-center gap-2"
      >
        {loading ? <Loader2 size={14} className="animate-spin" /> : <Zap size={14} strokeWidth={1.5} />}
        Compute
      </button>
    </form>
  );
}
